import _ from 'lodash'

const DOC_PARAM = 'doc'

export function parserParams(strs) {
	let retValue = {}
	_.forEach(strs.slice(1).split('&'), (param) => {
		let value = param.split('=')
		retValue[value[0]] = value[1]
	})
	
	return retValue
}

export function getDocUrl(params) {
	if (process.env.NODE_ENV === 'development' && params[DOC_PARAM] === undefined) {
		return 'http://www.mtcom.co.kr/vp/accident_report_viewer_sample.pdm'
	}
	return params[DOC_PARAM]
}



// WEBPACK FOOTER //
// ./src/utils/params.js